module.exports = __webpack_public_path__ + "img/wechat.e11c8283.svg";